export const programs = [
  {
    title: "환경 정화 사업",
    subtitle: "깨끗한 오늘이 아름다운 내일이 됩니다",
    description:
      "한마음회 봉사단의 환경정화사업은 \u201c우리가 사는 인천을 우리가 아름답게 만들자\u201d는 작은 마음에서 시작되었습니다. 거리 곳곳의 쓰레기를 줍는 \u2018줍깅\u2019 활동부터 시민들의 쉼터가 되는 장수천 둘레길 환경정화 조성사업 참여까지, 우리가 살아가는 공간을 더욱 깨끗하고 따뜻한 환경으로 만들기 위해 꾸준히 실천하고 있습니다. 작은 손길 하나가 모여 더 맑은 거리와 더 아름다운 인천을 만든다는 믿음으로 오늘도 한 걸음씩 함께하고 있습니다.",
    image:
      "https://static.wixstatic.com/media/17b604_be8f8591017047ce991d015adf24dbde~mv2.jpg",
    imageAlt: "환경 정화 봉사 활동",
  },
  {
    title: "이웃 나눔 사업",
    subtitle: "따뜻한 마음은 나눌 수록 커집니다",
    description:
      "한마음회 봉사단은 복지 사각지대에 놓인 취약계층 어르신들을 위해 따뜻한 나눔을 이어가고 있습니다. 계절의 정성을 담은 김장 나눔, 생활에 꼭 필요한 생필품 지원 등을 통해 단순한 도움을 넘어 마음의 온기를 전하고자 노력합니다. 누군가의 하루가 조금 더 따뜻해지고, 외롭지 않기를 바라는 마음으로 우리의 이웃 곁에 함께 서겠습니다.",
    image:
      "https://static.wixstatic.com/media/17b604_e52479d8ea1d4c1490b356cf84bba16e~mv2.jpg",
    imageAlt: "이웃 나눔 봉사 활동",
  },
  {
    title: "재능 나눔 사업",
    subtitle: "재능이 모이면 문화가 되고,\n마음이 모이면 행복이 됩니다",
    description:
      "한마음회 봉사단은 회원들의 다양한 재능과 경험을 바탕으로 인천 시민들과 따뜻한 문화를 나누고 있습니다. 작은 음악회, 플리마켓, 강연, 일일찻집, 원데이 클래스 등 다채로운 재능기부 행사를 통해 시민들이 일상 속에서 쉼과 즐거움, 배움과 소통을 경험할 수 있도록 노력하고 있습니다. 가진 것을 나누는 기쁨이 누군가에게는 새로운 감동과 희망이 되기를 바라며, 더 풍요로운 지역문화를 만들어가고 있습니다.",
    image:
      "https://static.wixstatic.com/media/17b604_57be3cdcfaae4bf3909b1d832e7172b0~mv2.jpg",
    imageAlt: "재능 나눔 봉사 활동",
  },
];